import { Component, Input } from '@angular/core';
import { ChangelogUtil } from '../../../util/changelog-util';

@Component({
  selector: 'gymfinder-changelog-cell',
  templateUrl: './changelog-cell.component.html',
  styleUrls: ['./changelog-cell.scss'],
  standalone: false,
})
export class ChangelogCellComponent {
  @Input()
  field: string;

  @Input()
  value: any;

  getDefaultValue() {
    if (typeof this.value === 'object') {
      return Object.keys(this.value)
        .map(k => `${k}: ${this.value[k]}`)
        .join('\n');
    }
    return this.value;
  }

  isEmpty() {
    if (typeof this.value === 'boolean') {
      return false;
    }

    if (this.value == null) {
      return true;
    }

    if (typeof this.value === 'string' || Array.isArray(this.value)) {
      return this.value.length === 0;
    }

    if (
      typeof this.value === 'object' &&
      Object.keys(this.value).length === 0
    ) {
      return true;
    }

    if (this.field === 'gymImages') {
      return ChangelogUtil.isGymImagesValueEmpty(this.value);
    }

    return false;
  }
}
